import { QueryClient } from '@tanstack/react-query'
import { ApiError } from '@/internationalization/api-client'

/**
 * One client for the app.
 *
 * The retry rule is the important line: a 401/403/404 is retried zero times.
 * The default (3 attempts) turns one denied request into three, tripling the
 * log noise and the time before the user sees the message.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && !error.isTransient) return false
        return failureCount < 2
      },
      refetchOnWindowFocus: true,
    },
    mutations: {
      retry: false,
    },
  },
})
